import getHeaders from '../../helpers/headers'
import axios from 'axios'
import config from '../../../constants/endpoints.js'

const {
  endpoints: {
    plugins: {
      topicSummary: { generate: urlGenerate, list: urlList },
    },
  },
} = config

/**
 * Generate Topic Summary.
 *
 * @param {String} data.conversationId Conversation ID
 */
const generateTopicSummary = (data) => axios.post(urlGenerate, data, { headers: getHeaders(true) })

/**
 * List Topic Summary.
 *
 * @param {String} data.conversationId Conversation ID
 * @param {Number} data.pageSize Page Size
 */
const listTopicSummary = (data) => axios.post(urlList, data, { headers: getHeaders(true) })

export default {
  generateTopicSummary,
  listTopicSummary
}
